import React, { Component } from 'react'
import { getComplaintTitles } from '../../Constant'

class ComplaintModel extends Component {
    state = {
        isLoading: false,
        title: '',
        description: '',
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
        })
    }

    componentDidMount = () => { }

    render() {
        return (
            <div style={{ width: 800, paddingRight: 40 }}>
                <div className="header">
                    <b>Complaint Form</b>
                </div>
                <div className="body m-t-20">
                    <div className="row">
                        <div className="col-12">
                            <div className="form-group row">
                                <label className="col-3 col-form-label">Title</label>
                                <div className="col-sm-9">
                                    <select
                                        name="title"
                                        className="form-control"
                                        onChange={this.handleChange}
                                        value={this.state.title}
                                    >
                                        <option value="">Select Type</option>
                                        {getComplaintTitles(this.props.type).map((data) => (
                                            <option
                                                value={data}
                                                key={data}
                                            >
                                                {data}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group row">
                                <label className="col-3 col-form-label">Description</label>
                                <div className="col-9">
                                    <textarea
                                        rows={3}
                                        className="form-control"
                                        onChange={this.handleChange}
                                        name="description"
                                        id="description"
                                        maxLength={200}
                                        placeholder=""
                                        value={this.state.description}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="text-right col-6 offset-6">
                            <button
                                onClick={() => this.props.postComplaint(this.state)}
                                className="btn hor-grd btn-grd-inverse offset-1"
                                disabled={this.state.title <= 0}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ComplaintModel
